// extracted by mini-css-extract-plugin
module.exports = {"spinner-wrapper":"LoadingSpinner_spinner-wrapper__I8iOP","loader":"LoadingSpinner_loader__NqY5r","rotation":"LoadingSpinner_rotation__3ksKo"};